import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import { TooltipProvider } from "./components/ui/tooltip.tsx";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Dashboard from "./components/Dashboard";
import AcceptInvitation from "./components/AcceptInvitation";
import DocumentTypeManager from "./components/fleet/DocumentTypeManager";
import AlertsPage from "./components/fleet/AlertsPage.jsx";
import GestionReglas from "./components/notificaciones/GestionReglas";
import PanicAlertPopup from "./components/PanicAlertPopup";
import { useEffect } from "react";

function App() {
 useEffect(() => {
    document.title = process.env.REACT_APP_BRAND_NAME || "Synkro Fleet";
  }, []);

  return (
    <AuthProvider>
      <TooltipProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Rutas públicas */}
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/invitation/:token" element={<AcceptInvitation />} />

              {/* Rutas protegidas */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              {/* ✅ NUEVA RUTA - Gestión de Tipos de Documentos */}
              <Route
                path="/document-types"
                element={
                  <ProtectedRoute>
                    <DocumentTypeManager />
                  </ProtectedRoute>
                }
              />
              {/* ✅ NUEVA RUTA - Página de Alertas */}
              <Route
                path="/alertas"
                element={
                  <ProtectedRoute>
                    <AlertsPage />
                  </ProtectedRoute>
                }
              />
              {/* Gestión de Reglas de Notificación — solo Super Admin */}
              <Route
                path="/sistema/configuracion/gestion-reglas"
                element={
                  <ProtectedRoute>
                    <GestionReglas />
                  </ProtectedRoute>
                }
              />
            </Routes>
           {/* ✅ BOTÓN FLOTANTE - fuera de Routes, visible en toda la app */}
            <PanicAlertPopup />
            {/* Componente de notificaciones globales */}
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  borderRadius: "10px",
                  background: "#363636",
                  color: "#fff",
                },
                success: {
                  duration: 3000,
                  style: {
                    background: "#10b981",
                  },
                },
                error: {
                  duration: 4000,
                  style: {
                    background: "#ef4444",
                  },
                },
              }}
            />
          </div>
        </Router>
      </TooltipProvider>
    </AuthProvider>
  );
}

export default App;
